module.exports = __webpack_public_path__ + "static/media/lv_dry_grapefruit.00b6158b.png";